export const GET_DISCIPLINARY_REQUEST = 'GET_DISCIPLINARY_REQUEST';
export const GET_DISCIPLINARY_FAILURE = 'GET_DISCIPLINARY_FAILURE';
export const GET_DISCIPLINARY_SUCCESS = 'GET_DISCIPLINARY_SUCCESS';
export const GET_DISCIPLINARY_RESPONSE_REQUEST = 'GET_DISCIPLINARY_RESPONSE_REQUEST';
export const GET_DISCIPLINARY_RESPONSE_FAILURE = 'GET_DISCIPLINARY_RESPONSE_FAILURE';
export const GET_DISCIPLINARY_RESPONSE_SUCCESS = 'GET_DISCIPLINARY_RESPONSE_SUCCESS';

